import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from './app/app.module';
import { routes } from './app/app.routes';

// Registering Syncfusion license key. Valid through Syncfusion v37 - see README.
registerLicense(
  'Ngo9BigBOggjGyl/VkJ+XU9Gf1RLVGpAY1J0WGBYb1xzflBPallYT3RfQFtjQH9Ud0NhXX9WdHZQQWtfWQ==;NxYtFisQPR08Cit/VkJ+XU9Gf1RLVGpAY1J0WGBYb1xzflBPallYT3RfQFtjQH9Ud0NhXX1YcXRTRmtfWQ==;Ix0oFS8QJAw9HSQvXkVkQlBadFZJVGpAd053R35afk5yd19DaVZUTX1dQl9lSXdScURlW3tcdnVXR2BXUkw='
);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [provideZoneChangeDetection(), provideRouter(routes), importProvidersFrom(AppModule)]
}).catch((err) => console.error(err));
